  <div  class="dynamic-field form-button col-1 offset-11"  [formGroup]="group">
    <button pButton class="ui-button-success" type="submit" label="{{config.name}}" [disabled]="config.disabled"></button>
  </div> 